define('meetings/embedded-launch',['require','durandal/app','web-urls','api-access','api-access'],function (require) {
    var app = require('durandal/app');
    var webUrls = require('web-urls');
    var meetingsApi = require('api-access').meetings;
    var userApi = require('api-access').user;

    var launch;
    require(
        ['launch'],
        function (embeddedLauncher) {
            launch = embeddedLauncher;
        },
        function () {
            launch = false;
        }
    );

    return function (meetingId, sessionTrackingId) {
        var sessionParam = sessionTrackingId ? '?sessionTrackingId=' + sessionTrackingId : '';
        if (!launch) {
            window.location = '/host/' + meetingId + sessionParam;
        }
        var userAgent = launch.model.userAgent();
        if (!userAgent.is.WINDOWS && !userAgent.is.MACOS) {
            // not supported by js launcher, route to launch service flow
            window.location = '/host/' + meetingId + sessionParam;
        } else {
            meetingsApi.launcherToken(meetingId, null, null, sessionTrackingId)
                .then(function (launchToken) {
                    return userApi.me()
                        .then(function (me) {
                            launch({
                                apiVersion: 2,
                                host: webUrls.get('launcherSvcUrl').split('https://').pop(),
                                product: 'g2m',
                                token: launchToken.token,
                                locale: me.locale.split('_')[0]
                            });
                            app.trigger('get:meetings');
                        });
                })
                .fail(function () {
                    window.location = '/host/' + meetingId + sessionParam;
                });
        }

        app.trigger('meeting:launched');
    };
});

